import { EMAIL_REGEX } from '../../../utils';

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!EMAIL_REGEX.test(values.email)) {
    errors.email = 'Invalid Email Address'
  } else if (!values.email.length) {
    errors.email = {_error: 'Please enter an email address'};
  }

  if (!values.name || !values.name.length) {
    errors.name = 'Required'
  }

  if (!values.subject || !values.subject.length) {
    errors.subject = 'Required'
  }

  if (!values.body || !values.body.length) {
    errors.body = 'Required'
  }

  return errors;
};

export default validate;
